<template>
    <div class="d-flex justify-content-start align-items-center">
        <span class="mr-2">{{ moment(target.session_at).format("MM/DD/YYYY") }}</span>
        <profile-picture
            v-if="target.created_by_user"
            :name="target.created_by_user.name"
            :size="'sm'"
            :url="target.created_by_user.profile_photo_url"
        ></profile-picture>
    </div>
</template>

<script>
import ProfilePicture from "../../ui/ProfilePicture";
export default {
    name: "BasicInfo",
    inject: ["target"],
    components: { ProfilePicture },
};
</script>

<style scoped></style>
